module.exports = [{"type":"hash","text":"Access"},{"type":"normal","text":"the base URL of Live Websocket Market Data ：wss://open-api-swap.bingx.com/swap-market"},{"type":"normal","text":"the base URL of VST Websocket Market Data ：wss://vst-open-api-ws.bingx.com/swap-market"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/websocket/introduce/01_connect.json
// module id = wa9k
// module chunks = 3